import axios from "axios";
export const insertComType = async (moduleData) => {
  try {
    const response = await axios.post("http://localhost:8080/webnet-hms/api/company-type/", moduleData);
    window.alert("Company Type inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting company type:", error);
  }
};